import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=6bf97b92&"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports